/** 文件说明
@Author: haibowang
@LastModifyTime: 2021-12-22  13:55:06
@Desc: 万知商务相关接口
**/
import ajax from './ajax'

// 获取主分类头信息(万知商务模块代码192)
export const queryGetSecCategory = (params) => {
  return ajax({
    url: '/public/v1/getSecCategory',
    method: 'get',
    params
  })
}

// 获取子分类头信息
// 根据主分类ID（belong_id），父分类ID(cid)来获取子分类列表
// 当cid传0代表获取第一级子分类
// 当cid传一级分类ID时表示获取第二级分类
// 当cid传二级分类ID时表示获取第三级分类
export const queryCategoryList = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcategory/categoryList',
    method: 'get',
    params
  })
}

// 获取子分类筛选的属性
// params cateid  子分类ID
export const queryAttributes = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcategory/filterAttr',
    method: 'get',
    params
  })
}

// 获取分类品牌
// params belong_id 主分类id 0代表所有
// params cateid  子分类ID 0代表所有
// params first_char  子分类ID 不传代表所有
export const queryBrandsByCategory = (params) => {
  return ajax({
    url: '/public/v1/mall/mallbrand/getCategorybrand',
    method: 'get',
    params
  })
}

// 根据分类筛选商品列表
// page 必填
// province 必填
// city 必填
// position 必填
export const queryGoodsAllByCondition = (params) => {
  return ajax({
    url: '/public/v1/mall/mallshop/goodsList',
    method: 'get',
    params
  })
}
// 根据用户输入搜索商品列表
// keyword 搜索关键字
// page 必填
// province 必填
// city 必填
// position 必填
export const queryGoodsByUserInput = (params) => {
  return ajax({
    url: '/public/v1/mall/mallshop/search',
    method: 'get',
    params
  })
}

// 获取商品评价列表
// goods_id 商品id
// page 分页
export const getGoodscomment = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/getGoodscomment',
    method: 'get',
    params
  })
}

// 获取商品详细信息
// goods_id 商品id
export const getGoodsDetail = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/getGoodsbaseinfo',
    method: 'get',
    params
  })
}

// 获取商品运费
// goods_id 商品id
// province city position
export const getGoodsShippingfee = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/getGoodsShippingfee',
    method: 'get',
    params
  })
}

// 获取商品详情属性
// goods_id 商品id
export const getGoodsattr = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/getGoodsattr',
    method: 'get',
    params
  })
}

// 获取商品某一个属性的货品库存，价格信息；
// goods_id 商品id
// attr 商品属性，格式：5,10；多个属性ID之间用英文逗号,隔开
export const getProductInfo = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/getProduct',
    method: 'get',
    params
  })
}
// 获取店铺基本信息
// shopid 店铺id
export const getShopbaseinfo = (params) => {
  return ajax({
    url: '/public/v1/mall/mallshop/getShopbaseinfo',
    method: 'get',
    params
  })
}
// 获取店铺商品列表
// page 页码
// shopid 店铺id
export const getShopgoods = (params) => {
  return ajax({
    url: '/public/v1/mall/mallshop/getShopgoods',
    method: 'get',
    params
  })
}

// 商家入驻申请
// 具体参数见api
export const shopRuzhu = (data) => {
  return ajax({
    url: '/public/v1/mall/mallshop/shopRuzhu',
    method: 'post',
    data: {...data, withToken: true}
  })
}

// 获取入驻主分类
export const getRuzhuMainCategory = () => {
  return ajax({
    url: '/public/v1/mall/mallcategory/getRuzhuMainCategory',
    method: 'get',
    params: {
      withToken: true
    }
  })
}

// 获取入驻子分类
export const getRuzhuSubCategory = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcategory/getRuzhuSubCategory',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 2022/2/12 二阶段开发
// 商品关注(需要用户登录)
export const focusGood = (params) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/guanZhu',
    method: 'get',
    params
  })
}
// 用户商品留言(需要用户登录)
export const liuYan = (data) => {
  return ajax({
    url: '/public/v1/mall/mallgoods/liuYan',
    method: 'post',
    data
  })
}
// 需求信息筛选(当用户选择分类，和城市时调用)
export const getRequireInfosByCateory = (params) => {
  return ajax({
    url: '/public/v1/mall/mallxuqiu/xuqiuList',
    method: 'get',
    params
  })
}
// 搜索需求信息筛选(输入关键词搜索需求信息时调用)
export const getRequireInfosByInput = (params) => {
  return ajax({
    url: '/public/v1/mall/mallxuqiu/xuqiuSearch',
    method: 'get',
    params
  })
}
// 发布需求信息
export const piublicRequireInfo = (data) => {
  return ajax({
    url: '/public/v1/mall/mallxuqiu/fabuXuqiu',
    method: 'post',
    data
  })
}
// 加入购物车(需要用户登录)
export const addGoodTocart = (data) => {
  return ajax({
    url: '/public/v1/mall/mallcart/addTocart',
    method: 'post',
    data
  })
}
// 获取用户购物车商品(需要用户登录)
export const getCargoods = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/getCartgoods',
    method: 'get',
    params: {
      withToken: true
    }
  })
}

// 删除购物车的商品(需要用户登录)
export const deleteCarGoods = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/delCartgoods',
    method: 'get',
    params: {...params, withToken: true}
  })
}

// 清空购物车(需要用户登录))
export const clearShoppingCart = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/cleanCart',
    method: 'get',
    params: {
      withToken: true
    }
  })
}
// 计算购物车中已选中商品数量和金额(需要用户登录)
// cart_value 购物车记录id
export const getCartgoodsprice = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/getCartgoodsprice',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 购物车中的商品数量+1
// recid 购物车id
// withToken: true
export const cartGoodsaddone = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/cartGoodsaddone',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 购物车中的商品数量-1
// recid 购物车id
// withToken: true
export const cartGoodsreduceone = (params) => {
  return ajax({
    url: '/public/v1/mall/mallcart/cartGoodsreduceone',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 订单-获取收获人地址列表数据
export const getShouhuoAddress = () => {
  return ajax({
    url: '/public/v1/mall/mallorder/getShouhuoinfo',
    method: 'get',
    params: {withToken: true}
  })
}
// 订单-获取提交订单商品信息
// cart_value 购物车id
// address_id 收获地址
export const getSubmitOrderinfo = (params) => {
  return ajax({
    url: '/public/v1/mall/mallorder/getSubmitOrderinfo',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 订单-计算提交订单金额信息
// cart_value 购物车id
// address_id 收获地址
// shopwuliu 店铺物流;格式 1:2,3:4 （1代表店铺ID，2代表物流ID；多个店铺物流之间用英文逗号隔开）
export const jsOrderfee = (data) => {
  return ajax({
    url: '/public/v1/mall/mallorder/jsOrderfee',
    method: 'post',
    data: {...data, withToken: true}
  })
}
// 提交订单
// cart_value 购物车id
// address_id 收获地址
// shopwuliu 店铺物流
export const confirmOrder = (data) => {
  return ajax({
    url: '/public/v1/mall/mallorder/submitOrderinfo',
    method: 'post',
    data: {...data, withToken: true}
  })
}
// 获取微信pc支付二维码
// order_sn 单号
export const payQrCode = (params) => {
  return ajax({
    url: '/public/v1/mall/getGoodsQrcode',
    method: 'get',
    params: {...params, withToken: true}
  })
}

// 商品预约功能(详情页中通过预约按钮操作（预约商品无法加入购物车)
// good_id 商品id
export const yuYueOpr = (params) => {
  return ajax({
    url: '/public/v1/mall/mallyuyue/yuYue',
    method: 'post',
    data: {...params, withToken: true}
  })
}
// 获取预约商品订单信息(点击立即抢购)
// 调用此接口的条件1.预约商品，2.在预约时间段内
// goods_id
// goods_number
// address_id
// spec
export const getYuyueOrderinfo = (params) => {
  return ajax({
    url: '/public/v1/mall/mallyuyue/getYuyueOrderinfo',
    method: 'get',
    params: {...params, withToken: true}
  })
}
// 提交预约商品订单(抢购确认)
export const submitQiangouorder = (params) => {
  return ajax({
    url: '/public/v1/mall/mallyuyue/submitQiangouorder',
    method: 'post',
    data: {...params, withToken: true}
  })
}
// 计算抢购订单金额
export const jsQianggouOrderfee = (params) => {
  return ajax({
    url: '/public/v1/mall/mallyuyue/jsQianggouOrderfee',
    method: 'post',
    data: {...params, withToken: true}
  })
}
// 在订单支付页面用于轮询查询当前订单的支付状态
export const queryOrder = (params) => {
  return ajax({
    url: '/public/v1/mall/queryOrder',
    method: 'get',
    params: {...params, withToken: true}
  })
}



// WEBPACK FOOTER //
// ./src/axios/wzmall.js